<template>
  <ResponsiveLayout>
    <div class="kds-main-wrapper">
      <p class="kds-typography-display-small">
        {{ $t('deeplink_fallback__title') }}
      </p>
      <BaseButton
        :text="$t('deeplink_service_open_app_button')"
        @click="redirectToDeeplink"
      />
    </div>
  </ResponsiveLayout>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import BaseButton from '@shared/components/BaseButton.vue'

const router = useRouter()
const route = useRoute()

const redirectToDeeplink = () => {
  window.location.redirectToDeeplink(route.query.deeplink)
}

if (!route.query.deeplink) {
  router.push({ path: '/' })
}
</script>

<style lang="scss" scoped></style>
